<template>
  <div class="content">
    <div class="chart" :style="{height:'350px',width:'100%'}" ></div>
    <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="68px">
      <el-form-item prop="ipaddr">
        <el-input
          v-model="queryParams.ipaddr"
          placeholder="请输入IP地址"
          clearable
          style="width: 240px;"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item prop="username">
        <el-input
          v-model="queryParams.name"
          placeholder="请输入模块名称"
          clearable
          style="width: 240px;"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="dateRange"
          style="width: 240px"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table ref="tables" border v-loading="loading" :data="list"  :default-sort="defaultSort" @sort-change="handleSortChange">
      <el-table-column type="index" width="55" align="center" />
      <el-table-column label="名称" align="center" prop="title" :show-overflow-tooltip="true"/>
      <el-table-column label="访问地址" align="center" prop="ipAddress" width="130" :show-overflow-tooltip="true" />
      <el-table-column label="国家" align="center" prop="country" :show-overflow-tooltip="true" >
        <template slot-scope="scope">
          <p>{{scope.row.country}}</p>
          <p v-if="scope.row.enCountry">{{scope.row.enCountry}}</p>
        </template>
      </el-table-column>
      <el-table-column label="省份" align="center" prop="region" :show-overflow-tooltip="true" >
        <template slot-scope="scope">
          <p>{{scope.row.region}}</p>
          <p v-if="scope.row.enRegion">{{scope.row.enRegion}}</p>
        </template>
      </el-table-column>
      <el-table-column label="城市" align="center" prop="city" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <p>{{scope.row.city}}</p>
          <p v-if="scope.row.enCity">{{scope.row.enCity}}</p>
        </template>
      </el-table-column>
      <el-table-column label="经度/纬度" align="center" prop="latitude" :show-overflow-tooltip="true" >
        <template slot-scope="scope">
          <p>{{scope.row.latitude}}</p>
          <p v-if="scope.row.longitude" style="color: #409eff;">{{scope.row.longitude}}</p>
        </template>
      </el-table-column>
      <el-table-column label="开始/结束日期" align="center" prop="startTime"  width="160">
        <template slot-scope="scope">
          <p>{{scope.row.startTime}}</p>
          <p v-if="scope.row.endTime" style="color: #409eff;">{{scope.row.endTime}}</p>
        </template>
      </el-table-column>
      <el-table-column label="停留时长" align="center" width="120">
        <template slot-scope="scope">
          {{ formatDuration(scope.row.duration) }}
        </template>
      </el-table-column>
      <el-table-column label="浏览器/操作系统" align="center" prop="browser" width="160"  :show-overflow-tooltip="true" >
        <template slot-scope="scope">
          <p>{{scope.row.browser}}</p>
          <p v-if="scope.row.os" style="color: #409eff;">{{scope.row.os}}</p>
        </template>
      </el-table-column>
      <el-table-column label="设备类型" align="center" prop="deviceType" />
      <el-table-column label="用户名称" align="center" prop="username"  width="160"></el-table-column>
      <el-table-column label="上报日期" align="center" prop="visitTime"  width="160"></el-table-column>
      <el-table-column label="屏幕分辨率" align="center" prop="screenResolution"  width="120"></el-table-column>
      <el-table-column label="最终上报" align="center" prop="isFinal"  width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.isFinal" style="color: #409eff;">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="getList"
    />
  </div>
</template>

<script>
import { visitorLog ,statisticsVisitorLog} from "@/api/api.js";
import * as echarts from "echarts"
import resize from '../dashboard/mixins/resize'

export default {
  name: "internationalSite",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选择用户名
      selectName: "",
      // 总条数
      total: 0,
      // 表格数据
      list: [],
      // 日期范围
      dateRange: [],
      // 默认排序
      defaultSort: {prop: 'loginTime', order: 'descending'},
      page: 1,
      pageSize: 10,
      // 查询参数
      queryParams: {
        ipaddr: undefined,
        name: undefined,
      },
      chart: null,
      chartData: {
        times: [],
        uniqueVisitors: []
      }
    };
  },
  created() {
    this.getList();
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el.querySelector('.chart'))
      statisticsVisitorLog().then(res => {
        this.chartData = res.data.data
        this.setOptions(this.chartData)
      })
      
    },
    /** 查询登录日志列表 */
    getList() {
      this.loading = true;
      let params = {
        model:{
          ...this.addDateRange(this.queryParams, this.dateRange)
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      visitorLog(params).then(res => {
          this.list = res.data.data.records;
          this.total = res.data.data.total;
          this.loading = false;
        }
      );
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = [];
      this.resetForm("queryForm");
      this.$refs.tables.clearSort();
      this.handleQuery();
    },
    /** 排序触发事件 */
    handleSortChange(column, prop, order) {
      this.queryParams.sort = column.prop;
      this.queryParams.order = column.order;
      this.getList();
    },
    /** 新增：毫秒转小时分秒格式 */
    formatDuration(milliseconds) {
      if (!milliseconds || milliseconds < 1000) {
        return '0秒';
      }
      
      const seconds = Math.floor(milliseconds / 1000);
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;
      
      let result = '';
      if (hours > 0) {
        result += hours + '小时';
      }
      if (minutes > 0 || hours > 0) {
        result += minutes + '分钟';
      }
      result += secs + '秒';
      
      return result;
    },
    
    setOptions({ times, uniqueVisitors } = {}) {
      this.chart.setOption({
        title: {
          text: '日访客数'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        toolbox: {
          feature: {
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ['line', 'bar'] },
            restore: { show: true },
            saveAsImage: { show: false }
          }
        },
        color: ['#34bfa3','#f4516c', '#36a3f7'],
        legend: {
          data: ['访客数']
        },
        xAxis: [
          {
            type: 'category',
            data: times,
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: '访客数',
            type: 'bar',
            data: uniqueVisitors
          },
          {
            name: '访客数走势',
            type: 'line',
            label: {
                show: false,
            },
            tooltip: {
                show: false,
            },
            itemStyle: {
                color: '#4870DB',
            },
            lineStyle:{
                width:1
            },
            data: uniqueVisitors
          }
        ]
      })
    }
  }
};
</script>

